// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryContentPageLink-module__wrapper___SGOSV","root":"CategoryContentPageLink-module__root___yOXQS","hidden":"CategoryContentPageLink-module__hidden___dB8cD"};